import { render } from "./UploadPanel.vue?vue&type=template&id=4336913e&scoped=true&ts=true"
import script from "./UploadPanel.vue?vue&type=script&lang=ts"
export * from "./UploadPanel.vue?vue&type=script&lang=ts"

import "./UploadPanel.vue?vue&type=style&index=0&id=4336913e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4336913e"]])

export default __exports__